import type { MutableRefObject } from 'react';
import { useSelector } from 'react-redux';
import type { Selector } from 'reselect';

function useSelectorRef<T>(
  selector: Selector<unknown, T>,
  ref: MutableRefObject<T>,
) {
  useSelector<unknown, T>(selector, (_, current) => {
    // eslint-disable-next-line @exodus/mutable/no-param-reassign-prop-only
    ref.current = current;
    return true;
  });
}

export default useSelectorRef;
